'use strict';

import ngResource from 'angular-resource';

function RetryService ($resource) {
    return $resource(
        '/api/retry', {},
        { create : { method: 'POST', isArray: false } }
    )
}

export default angular.module('leptonApp.RetryService', ['ngResource'])
    .factory('RetryService', ['$resource', RetryService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/retry/retry.service.js